import { EMPTY_OBJECT } from '../constants/common'
import { FLAT_ENTITY } from '../constants/entity'
import { getApi, patchApi, postApi, putApi } from '../utils/api'

export function createFlat(data) {
  return postApi({ data, endpoint: `idwell-api/api/v3/construction/flats/` })
}

export function getFlatProfile(id) {
  return getApi({ endpoint: `api/v2/flat/${id}/` })
}

export function updateFlatProfile({ data, id }) {
  return patchApi({ data, endpoint: `api/v2/flat/${id}/` })
}

export function getFlatInfo({ id, options }) {
  return getApi({ endpoint: `api/flat/${id}/info/`, options })
}

export function updateFlatInfo({ data, id, options }) {
  return patchApi({ data, endpoint: `api/flat/${id}/info/`, options })
}

export function getFlats(params) {
  return getApi({
    endpoint: `idwell-api/api/v3/construction/flat-options/`,
    params,
  })
}

export function getFlatRoomTypes(params) {
  return getApi({
    endpoint: 'api/room-type/',
    params,
  })
}

export function getFlatCategories(params) {
  return getApi({
    endpoint: 'api/flat-category/',
    params,
  })
}

export function getFlatConditions(params) {
  return getApi({
    endpoint: 'api/flat-condition/',
    params,
  })
}

export function getFlatContractTypes(params) {
  return getApi({
    endpoint: 'api/contract-type/',
    params,
  })
}

export function getFlatSpecifics(params) {
  return getApi({
    endpoint: 'api/flat-specifics/',
    params,
  })
}

export function searchFlats({
  apiConfig = EMPTY_OBJECT,
  archived = false,
  query,
}) {
  return getApi({
    ...apiConfig,
    endpoint: `api/flat/live-search/`,
    params: { ...apiConfig.params, archived, query },
  })
}

export function checkFlatsExportTask(id) {
  return getApi({ endpoint: `api/flat/export/task/${id}/` })
}

export function startFlatsExport(data) {
  return postApi({
    data,
    endpoint: 'idwell-api/api/v3/construction/flats/export/',
  })
}

export function loadFlatsExportFieldsList() {
  return getApi({ endpoint: 'api/flat/export/fields-list/' })
}

export function getFlatsEmailRecipients(data) {
  return postApi({
    data,
    endpoint: 'idwell-api/api/v3/construction/flats/email-recipients/',
  })
}

export function performFlatsMassAction(data) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/construction/${FLAT_ENTITY.plural}/mass-action/`,
  })
}

export function updateFlatsTableConfig(data) {
  return putApi({
    data,
    endpoint: `idwell-api/api/v3/table/tables/${FLAT_ENTITY.plural}/config/`,
  })
}
